import SectionModule from './section.module'

export default SectionModule
